import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WaitDialog = _resolveComponent("WaitDialog")!
  const _component_GhostDraftView = _resolveComponent("GhostDraftView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_WaitDialog, {
      isActive: $setup.isWaiting,
      title: "What are you waiting for?"
    }, null, 8 /* PROPS */, ["isActive"]),
    _createVNode(_component_GhostDraftView, { dataCaptureArgs: $setup.dataCaptureArgs }, null, 8 /* PROPS */, ["dataCaptureArgs"])
  ], 64 /* STABLE_FRAGMENT */))
}